import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageRestaurant,
  showMessage,
} from "../../Functionalities/Functions";
import MapView from "./MapView";
import RadiusField from "./Components/RadiusField";
import AddTopComponent from "../../CoreComponents/AddTopComponent";
import AddBottomComponent from "../../CoreComponents/AddBottomComponent";
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";
import { googleApiKey, franchise } from "../../Functionalities/Config";
import { ManageFranchise, ManageSettingsAdmin } from "../Franchise/Logic";
import { validateEmail } from "../../Functionalities/Validation";
import { PICTURE_SHAPES } from "../../Functionalities/pictureShapes";

function Body() {
  const [disable, setdisable] = useState(false);
  const [loading, setLoading] = useState(true);

  const getSavedState = (key, defaultValue) => {
    const saved = localStorage.getItem("add_restaurant_form_state");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed[key] !== undefined) {
          if (key === 'data') {
            return { ...parsed.data, images: [] };
          }
          return parsed[key];
        }
      } catch (e) {
        console.error("Error parsing saved state", e);
      }
    }
    return defaultValue;
  };

  const [data, setData] = useState(() => getSavedState('data', {
    id: "",
    branch_name: "",
    dual_name: "",
    mobile: "",
    email: "",
    fssai: "",
    place: "",
    latitude: "",
    longitude: "",
    address: "",
    description: "",
    is_featured: false,
    images: [],
    managers: [],
    admin: [],
    commission: 0,
    time_to_cook: "",
    expence_meter: "200 for 2",
    radius: 0.0,
    available_radius: 0.0,
    self_pickup: false,
    self_pickup_restaurent_charge: "",
    pure_veg: false,
    is_celebration_store: false,
    is_cake_store: false,
    free_delivery: false,
  }));

  const [franchiseData, setFranchiseData] = useState({
    latitude: "",
    longitude: "",
  });

  const [admins, setAdmins] = useState(() => getSavedState('admins', {
    admin_name: "",
    admin_username: "",
    admin_password: "",
    confirm_admin_password: "",
    admin_mobile: "",
  }));

  const [manager, setManager] = useState(() => getSavedState('manager', {
    id: "",
    manager_name: "",
    manager_username: "",
    manager_password: "",
    manager_mobile: "",
    confirm_manager_password: "",
  }));

  const [latitude, setLatitude] = useState(() => getSavedState('latitude', ""));
  const [compression, setCompression] = useState(true);
  const [longitude, setLongitude] = useState(() => getSavedState('longitude', ""));
  const [address, setAddress] = useState(() => getSavedState('address', ""));
  const [apiKey, setapiKey] = useState("");

  useEffect(() => {
    getApiKey();
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "add_restaurant_form_state",
      JSON.stringify({ data, admins, manager, latitude, longitude, address })
    );
  }, [data, admins, manager, latitude, longitude, address]);

  const getApiKey = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf"
    );
    res.then((result) => {
      if (result?.data?.Message?.param_value && result.data.Message.param_value !== "XXXXXXXXXXXXXX") {
        setapiKey(result.data.Message.param_value);
      } else {
      }
    });
  };

  const handleCoordinatesChange = (latt, longi) => {
    setLatitude(latt);
    setLongitude(longi);

    const locToPlace = (lat, long) => {
      // var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + long + `&key=${googleApiKey}&sensor=true`;
      var url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        `&key=${apiKey ? apiKey : googleApiKey}&sensor=true`;
      axios
        .get(url)
        .then(function (response) {
          // setData({ ...data, address: response.data.results[0].formatted_address, latitude: latt, longitude: longi })
          setAddress(response.data.results[0].formatted_address);
        })
        .catch(function (error) {
          // void 0
        });
    };
    locToPlace(latt, longi);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      // void 0
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(prev => ({ ...prev, address: address }));
  }, [address]);

  useEffect(() => {
    setData(prev => ({ ...prev, latitude: latitude }));
  }, [latitude]);

  useEffect(() => {
    setData(prev => ({ ...prev, longitude: longitude }));
  }, [longitude]);

  useEffect(() => {
    getFranchiseData();
  }, []);

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  const franchiseId = franchise.id;

  const getFranchiseData = () => {
    let res = ManageFranchise("", "", "get", `id=${franchiseId}`);
    res
      .then((result) => {
        if (result.data.results.length) {
          setFranchiseData({
            ...franchiseData,
            latitude: result.data.results[0].latitude,
            longitude: result.data.results[0].longitude,
          });
        }
      })
      .catch((err) => {
      });
  };

  const Mapdata = [
    {
      id: 1,
      name: "Park Slope",
      latitude: "40.6710729",
      longitude: "-73.9988001",
    },
    {
      id: 2,
      name: "Bushwick",
      latitude: "40.6942861",
      longitude: "-73.9389312",
    },
    {
      id: 3,
      name: "East New York",
      latitude: "40.6577799",
      longitude: "-73.9147716",
    },
  ];

  Mapdata[0].circle = {
    radius: 3000,
    options: {
      strokeColor: "#ff0000",
    },
  };

  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">
          <AddTopComponent path={"restaurants"} />

          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <form>
                    <div className="card-header">
                      <h4 className="card-title">Shop Admin</h4>
                    </div>
                    <div className="card-body">
                      <div className="basic-form">
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>
                              Name <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={admins.admin_name}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_name: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Username <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={admins.admin_username}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_username: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Password <span className="required">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              value={admins.admin_password}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_password: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>
                              Confirm Password{" "}
                              <span className="required">*</span>
                            </label>
                            <input
                              type="password"
                              className="form-control"
                              value={admins.confirm_admin_password}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  confirm_admin_password: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label>
                              Mobile
                            </label>
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min={0}
                              className="form-control"
                              onKeyDown={(evt) =>
                                ((evt.key === "e" || evt.key === "-") &&
                                  evt.preventDefault()) ||
                                (evt.key === "E" && evt.preventDefault())
                              }
                              onWheelCapture={(e) => {
                                e.target.blur();
                              }}
                              value={admins.admin_mobile}
                              onChange={(e) => {
                                setAdmins({
                                  ...admins,
                                  admin_mobile: e.target.value.slice(0, 10),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-header">
                      <h4 className="card-title">Restaurant Details</h4>
                    </div>
                    <br></br>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Restaurant name <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.branch_name}
                          onChange={(e) =>
                             setData(prev => ({ ...prev, branch_name: e.target.value }))
                           }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Mobile <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.mobile}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) =>
                            setData((prev) => ({
                              ...prev,
                              mobile: e.target.value.slice(0, 10),
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Fssai Code <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.fssai}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) => {
                            const val = e.target.value.slice(0, 14);
                            setData((prev) => ({
                              ...prev,
                              fssai: val,
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Restaurant Radius
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data?.radius}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) =>
                            setData((prev) => ({ ...prev, radius: e.target.value }))
                          }
                        />
                      </div>
                    </div>

                    <RadiusField
                      value={data?.available_radius}
                      onChange={(available_radius) => setData((prev) => ({ ...prev, available_radius }))}
                    />

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Commission in % <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.commission}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onWheelCapture={(e) => {
                            e.target.blur();
                          }}
                          onChange={(e) =>
                            e.target.value >= 100
                              ? showMessage(
                                  "Commission should be less than 100",
                                  "danger",
                                  "Error!",
                                  "top",
                                  "top-right"
                                )
                              : setData((prev) => ({ ...prev, commission: e.target.value }))
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Email </label>
                      <div className="col-sm-9">
                        <input
                          type="email"
                          className="form-control"
                          value={data.email}
                          onChange={(e) =>
                            setData((prev) => ({ ...prev, email: e.target.value }))
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Expense meter in ₹ <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.expence_meter}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" || evt.key === "-") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                           onChange={(e) =>
                             setData(prev => ({
                               ...prev,
                               expence_meter: e.target.value,
                             }))
                           }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Self Pickup Enabled?
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          onChange={(e) => {
                            setData(prev => ({ ...prev, self_pickup: e.target.value === "true" }));
                          }}
                          value={data?.self_pickup}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </div>
                    </div>

                    {data.self_pickup && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Store charge for self-pickup orders (blank = same as normal)
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="number"
                            min={0}
                            className="form-control"
                            onWheelCapture={(e) => {
                              e.target.blur();
                            }}
                            onKeyDown={(evt) =>
                              ((evt.key === "e" || evt.key === "-") &&
                                evt.preventDefault()) ||
                              (evt.key === "E" && evt.preventDefault())
                            }
                            value={data.self_pickup_restaurent_charge}
                            onChange={(e) =>
                              setData((prev) => ({
                                ...prev,
                                self_pickup_restaurent_charge: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Pure Veg Restaurant?
                      </label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          onChange={(e) =>
                            setData(prev => ({ ...prev, pure_veg: e.target.value === "true" }))
                          }
                          value={data?.pure_veg}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Is Celebration Store?
                      </label>
                      <div className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          style={{ marginLeft: 0, marginTop: 0 }}
                          checked={data.is_celebration_store}
                          onChange={(e) => {
                            setData(prev => ({
                              ...prev,
                              is_celebration_store: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Cake store
                      </label>
                      <div className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          style={{ marginLeft: 0, marginTop: 0 }}
                          checked={data.is_cake_store}
                          onChange={(e) => {
                            setData(prev => ({
                              ...prev,
                              is_cake_store: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Free delivery
                      </label>
                      <div className="col-sm-9" style={{ display: "flex", alignItems: "center" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          style={{ marginLeft: 0, marginTop: 0 }}
                          checked={data.free_delivery}
                          onChange={(e) => {
                            setData(prev => ({
                              ...prev,
                              free_delivery: e.target.checked,
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Average Cooking Time (in minutes){" "}
                        <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="number"
                          className="form-control"
                          value={data.time_to_cook}
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={(evt) =>
                            ((evt.key === "e" ||
                              evt.key === "-" ||
                              evt.key === "+") &&
                              evt.preventDefault()) ||
                            (evt.key === "E" && evt.preventDefault())
                          }
                          onChange={(e) =>
                            setData({
                              ...data,
                              time_to_cook: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row"></div>
                    {!loading && apiKey !== undefined ? (
                      <div
                        style={{
                          marginBottom: 20,
                          border: "1px solid #faccbe",
                          padding: 10,
                          borderRadius: 20,
                        }}
                      >
                        <MapView
                          onChange={handleCoordinatesChange}
                          latitude={franchiseData.latitude}
                          longitude={franchiseData.longitude}
                        />
                      </div>
                    ) : (
                      <div>
                        <div class="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Latitude
                          </label>
                          <div class="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              required
                              value={data.latitude}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  latitude: e.target.value,
                                })
                              }
                            ></input>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Longitude
                          </label>
                          <div class="col-sm-9">
                            <input
                              type="number"
                              className="form-control"
                              required
                              value={data.longitude}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  longitude: e.target.value,
                                })
                              }
                            ></input>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Address <span className="required">*</span>
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          value={data.address}
                           onChange={(e) =>
                             setData(prev => ({ ...prev, address: e.target.value }))
                           }
                        />
                      </div>
                    </div>

                    <div class="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Description
                      </label>
                      <div class="col-sm-9">
                        <textarea
                          class="form-control"
                          rows="4"
                          id="comment"
                          required
                          value={data.description}
                           onChange={(e) =>
                             setData(prev => ({ ...prev, description: e.target.value }))
                           }
                        ></textarea>
                      </div>
                    </div>

                    <br />

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">
                        Images{"(94x76)"}
                        <span className="required">*</span>
                        <br />
                        <b>Compress image </b>
                        <input
                          type="checkbox"
                          checked={compression}
                          onChange={(e) => {
                            setCompression(e.target.checked);
                            setData(prev => ({ ...prev, images: "" }));
                          }}
                        />
                      </label>

                      <div className="col-sm-9">
                        <ImageUploadWithCrop
                          value={data.images}
                          onChange={(file) =>
                            setData(prev => ({
                              ...prev,
                              images: file,
                            }))
                          }
                          {...PICTURE_SHAPES.restaurant}
                          compress={compression}
                        />
                      </div>
                    </div>

                    <br></br>
                    <div className="text-center">
                      <div className="form-group column">
                        <a
                          data-toggle="modal"
                          data-target="#sendMessageModal"
                          href=""
                        >
                          <span
                            style={{ marginRight: 10 }}
                            className="item badge badge-circle badge-success "
                          >
                            <i class="ti-plus"></i>
                          </span>
                          Add Managers
                        </a>

                        <div className="modal fade" id="sendMessageModal">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Add Managers</h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Name
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={manager.manager_name}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_name: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Username
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={manager.manager_username}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_username: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Password
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="password"
                                          className="form-control"
                                          value={manager.manager_password}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_password: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Confirm Password
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="password"
                                          className="form-control"
                                          value={
                                            manager?.confirm_manager_password
                                          }
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              confirm_manager_password:
                                                e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <label className="text-black font-w600">
                                          Phone{" "}
                                          <span className="required">*</span>{" "}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={manager.manager_mobile}
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          onChange={(e) => {
                                            setManager({
                                              ...manager,
                                              manager_mobile:
                                                e.target.value.slice(0, 10),
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {/* create manager */}
                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button
                                          type="submit"
                                          data-dismiss="modal"
                                          style={{ marginRight: 5 }}
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="submit"
                                          data-dismiss={"modal"}
                                          style={{ marginRight: 5 }}
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setErrors([]);
                                            if (manager.manager_name === "") {
                                              setErrors(["Manager name"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_username === ""
                                            ) {
                                              setErrors(["Manager username"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password === ""
                                            ) {
                                              setErrors(["Manager password"]);
                                              return;
                                            }

                                            if (
                                              manager.manager_password.length <
                                              5
                                            ) {
                                              setErrors([
                                                "Password must be more than 5 characters",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.confirm_manager_password ===
                                              ""
                                            ) {
                                              setErrors([
                                                "Manager confirm password",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password !==
                                              manager?.confirm_manager_password
                                            ) {
                                              setErrors([
                                                "Manager confirm password not match",
                                              ]);
                                              return;
                                            }
                                            if (manager.manager_mobile === "") {
                                              setErrors(["Manager mobile"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_mobile.length < 10
                                            ) {
                                              setErrors([
                                                "Manager mobile not 10 digits",
                                              ]);
                                              return;
                                            }
                                            setData({
                                              ...data,
                                              managers: [
                                                ...data.managers,
                                                { ...manager, id: Date.now() },
                                              ],
                                            });
                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                            showMessage(
                                              "Manager successfully added!",
                                              "success",
                                              "Success!",
                                              "top",
                                              "top-right",
                                              0
                                            );
                                          }}
                                        >
                                          Submit and close
                                        </button>
                                        <button
                                          className="submit btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setErrors([]);
                                            if (manager.manager_name === "") {
                                              setErrors(["Manager name"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_username === ""
                                            ) {
                                              setErrors(["Manager username"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password === ""
                                            ) {
                                              setErrors(["Manager password"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_password.length <
                                              5
                                            ) {
                                              setErrors([
                                                "Password must be more than 5 characters",
                                              ]);
                                              return;
                                            }
                                            if (
                                              manager.confirm_manager_password ===
                                              ""
                                            ) {
                                              setErrors([
                                                "Manager confirm password",
                                              ]);
                                              return;
                                            }

                                            if (
                                              manager.manager_password !==
                                              manager.confirm_manager_password
                                            ) {
                                              setErrors([
                                                "Manager confirm password not match",
                                              ]);
                                              return;
                                            }
                                            if (manager.manager_mobile === "") {
                                              setErrors(["Manager mobile"]);
                                              return;
                                            }
                                            if (
                                              manager.manager_mobile.length < 10
                                            ) {
                                              setErrors([
                                                "Manager mobile not 10 digits",
                                              ]);
                                              return;
                                            }

                                            if (
                                              manager.manager_mobile ===
                                              admins.admin_mobile
                                            ) {
                                              setErrors([
                                                "admin and manager mobile numbers are same",
                                              ]);
                                              return;
                                            }
                                            setData({
                                              ...data,
                                              managers: [
                                                ...data.managers,
                                                { ...manager, id: Date.now() },
                                              ],
                                            });
                                            setManager({
                                              id: "",
                                              manager_name: "",
                                              manager_username: "",
                                              manager_password: "",
                                              manager_mobile: "",
                                              confirm_manager_password: "",
                                            });
                                            showMessage(
                                              "Manager successfully added!",
                                              "success",
                                              "Success!",
                                              "top",
                                              "top-right",
                                              0
                                            );
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {data.managers.length > 0 &&
                        data.managers.map((man) => {
                          return (
                            <p>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  setData({
                                    ...data,
                                    managers: data.managers.filter(
                                      (var_item) => var_item.id !== man.id
                                    ),
                                  });
                                  showMessage(
                                    "Manager successfully removed!",
                                    "success",
                                    "Success!",
                                    "top",
                                    "top-right",
                                    0
                                  );
                                }}
                                className="btn mr-2"
                                style={{ color: "red" }}
                                href=""
                              >
                                <span className="item">
                                  <i class="ti-trash"></i>
                                </span>
                              </a>{" "}
                              firstname : {man.manager_name} - Username :{" "}
                              {man.manager_username} - Mobile :{" "}
                              {man.manager_mobile}
                            </p>
                          );
                        })}
                    </div>

                    <AddBottomComponent
                      disable={disable}
                      saveButton={(e) => {
                        e.preventDefault();
                        setdisable(true);
                        setErrors([]);

                        if (data.description === "") {
                          setdisable(false);
                          setErrors(["Description"]);
                          return;
                        }
                        if (admins.admin_name === "") {
                          setdisable(false);
                          setErrors(["Admin name"]);
                          return;
                        }
                        if (admins.admin_username === "") {
                          setdisable(false);
                          setErrors(["Admin username"]);
                          return;
                        }
                        if (admins.admin_password === "") {
                          setdisable(false);
                          setErrors(["Admin password"]);
                          return;
                        }
                        if (admins.admin_password.length < 5) {
                          setdisable(false);
                          setErrors([
                            "Password must be more than 5 characters",
                          ]);
                          return;
                        }
                        if (admins.confirm_admin_password === "") {
                          setdisable(false);
                          setErrors(["Admin confirm password"]);
                          return;
                        }
                        if (
                          admins.admin_password !==
                          admins.confirm_admin_password
                        ) {
                          setdisable(false);
                          setErrors(["Admin password mismatch"]);
                          return;
                        }
                        if (admins.admin_mobile && admins.admin_mobile.length < 10) {
                          setdisable(false);
                          setErrors(["Admin Mobile number must be 10 digits"]);
                          return;
                        }
                        if (data.email) {
                          if (!validateEmail(data.email)) {
                            setdisable(false);

                            setErrors(["Invalid Email"]);
                            return;
                          }
                        }

                        if (data.branch_name === "") {
                          setdisable(false);
                          setErrors(["Restaurant name"]);
                          return;
                        }
                        if (data.mobile === "") {
                          setdisable(false);
                          setErrors(["Restaurant mobile"]);
                          return;
                        }

                        if (data.mobile.length < 10) {
                          setdisable(false);
                          setErrors(["Mobile number must be 10 digits"]);
                          return;
                        }

                        if (data.fssai === "" || data.fssai <= 0) {
                          setdisable(false);
                          setErrors(["Restaurant Fssai Code"]);
                          return;
                        }
                        if (data.commission === "") {
                          setdisable(false);
                          setErrors(["commission"]);
                          return;
                        }
                        if (data.expence_meter === "") {
                          setdisable(false);
                          setErrors(["Expense meter"]);
                          return;
                        }
                        if (
                          data.time_to_cook === "" ||
                          data.time_to_cook <= 0
                        ) {
                          setdisable(false);
                          setErrors(["Average cooking time"]);
                          return;
                        }
                        if (data.latitude === "") {
                          setdisable(false);
                          setErrors(["Pick Restaurant location from map"]);
                          return;
                        }
                        if (data.longitude === "") {
                          setdisable(false);
                          setErrors(["Pick Restaurant location from map"]);
                          return;
                        }
                        if (data.address === "") {
                          setdisable(false);
                          setErrors(["Address"]);
                          return;
                        }
                        if (data.images.length === 0) {
                          setdisable(false);
                          setErrors(["Images"]);
                          return;
                        }
                        if (admins.admin_mobile && manager.manager_mobile === admins.admin_mobile) {
                          setdisable(false);
                          setErrors(["admin and manager mobile number same"]);
                          return;
                        }

                        var data_obj = {
                          ...data,
                          admin: [...data.admin, admins],
                        };

                        let res = ManageRestaurant(e, data_obj, "add", "");

                        res
                          .then((res) => {
                            setdisable(false);
                            if (res.data.Status === true) {
                              showMessage(
                                "Restaurant successfully added!",
                                "success",
                                "Success!",
                                "top",
                                "top-right",
                                0
                              );
                              localStorage.removeItem("add_restaurant_form_state");
                              setData({
                                id: "",
                                branch_name: "",
                                dual_name: "",
                                mobile: "",
                                email: "",
                                fssai: "",
                                place: "",
                                latitude: "",
                                longitude: "",
                                address: "",
                                description: "",
                                is_featured: false,
                                images: [],
                                managers: [],
                                admin: [],
                                commission: 0,
                                expence_meter: "200 for 2",
                                time_to_cook: "",
                                radius: 0.0,
                                available_radius: 0.0,
                                is_celebration_store: false,
                                is_cake_store: false,
                              });
                              setAdmins({
                                admin_name: "",
                                admin_username: "",
                                admin_password: "",
                                admin_mobile: "",
                                confirm_admin_password: "",
                              });
                              setAddress("");
                              setLatitude("");
                              setLongitude("");
                              window.location.replace(
                                `/restaurants/${data.id}`
                              );
                            } else {
                              if (res.data.rejected) {
                                for (
                                  var i = 0;
                                  i < res.data.rejected.length;
                                  i++
                                ) {
                                  if (res.data.rejected[i].error) {
                                    showMessage(
                                      res.data.rejected[i].manager_name +
                                        " : " +
                                        res.data.rejected[i].error,
                                      "danger",
                                      "Failed!",
                                      "top",
                                      "top-right",
                                      0
                                    );
                                  }
                                }
                              } else {
                                showMessage(
                                  res.data.Error,
                                  "danger",
                                  "Failed!",
                                  "top",
                                  "top-right",
                                  0
                                );
                              }
                            }
                          })
                          .catch((err) => err);
                      }}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddRestaurant() {
  const headers = "Create Restaurant";

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddRestaurant;
